/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Monday"] = "MONDAY";
    DayOfWeek["Tuesday"] = "TUESDAY";
    DayOfWeek["Wednesday"] = "WEDNESDAY";
    DayOfWeek["Thursday"] = "THURSDAY";
    DayOfWeek["Friday"] = "FRIDAY";
    DayOfWeek["Saturday"] = "SATURDAY";
    DayOfWeek["Sunday"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export function DayOfWeekFromJSON(json) {
    return DayOfWeekFromJSONTyped(json, false);
}
export function DayOfWeekFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function DayOfWeekToJSON(value) {
    return value;
}
